<template lang="pug">
.find-tier
  form(@submit.prevent="")
    .input-container
      input.input(v-model="code" type="text")
      label.label(:class="{ show: code }") Código

    shActionButton(:isForm="true" :action="getTier" text="Obtener Nivel" textRunning="Obteniendo")

    div(v-if="Object.keys(itemsFounded).length")
      .results-container
        .products-grid
          .product-section(v-for="product in Object.keys(itemsFounded)" :key="product")
            h3.product-name.uppercase {{ product }}
            img.product-image(:src="images[product]" v-if="images[product]")
            .table-container
              table.results-table
                thead
                  tr
                    th Talla
                    th Niveles
                    th Acciones
                tbody
                  tr(v-for="size in Object.keys(itemsFounded[product])" :key="`${product}-${size}`")
                    td.size-cell {{ size }}
                    td.tiers-cell
                      .tiers-list(v-if="itemsFounded[product][size] && itemsFounded[product][size].length")
                        span.tier-badge.relative(v-for="tier in itemsFounded[product][size]")
                          div
                            span {{ tier }}
                            shDeleteTier(:nameProduct="product" :tier="tier" :size="size" @deleted="() => { deleteTier(product, size, tier) }")
                            shAddTier(:nameProduct="product" :tier="tier" :size="size" @added="() => { addTier(product, size, tier) }")
                      span.no-tiers-text(v-else) Sin niveles
                    td.actions-cell
                      button.delete-btn(@click="deleteRow(product, size)" title="Eliminar fila")
                        img(src="@/assets/times.svg" alt="Eliminar")

      shActionButton(:action="deleteData" text="Borrar Datos" textRunning="Borrando")
</template>

<script>
import gql from '@my/graphql'
import gqlProduct from '@/graphql/product'
import mForm from '@/mixins/form'
import modals from '@my/store/modals'
import shDeleteTier from '../../ecommerce/DeleteTier.vue'
import shAddTier from '../../ecommerce/AddTier.vue'

export default {
  name: 'FindTier',

  mixins: [mForm],

  components: {
    shDeleteTier,
    shAddTier
  },

  data () {
    return {
      code: '',
      itemsFounded: {},
      images: {}
    }
  },

  computed: {
    tableRows () {
      const rows = []
      for (const product in this.itemsFounded) {
        for (const size in this.itemsFounded[product]) {
          rows.unshift({
            product,
            size,
            tiers: this.itemsFounded[product][size]
          })
        }
      }
      return rows
    }
  },

  methods: {
    async getTier () {
      if (!this.code) return
      const code = this.code.trim().toLowerCase()

      const separator = '-'
      const isCode = code.includes(separator)
      const product = isCode ? code.split(separator)[0] : code
      const sizeProduct = isCode ? code.split(separator)[1] : null
      this.getTiers(product, sizeProduct)
    },

    async getTiers (product, sizeProduct) {
      const mutation = gqlProduct.GET_TIERS_BY_PRODUCT
      const options = { product }

      const response = await gql.mutate(mutation, options)

      if (response && response.data && response.data.getByProduct) {
        const data = response.data.getByProduct

        if (!this.itemsFounded[product]) this.$set(this.itemsFounded, product, {})

        if (data.sizes && data.tiers) {
          if (sizeProduct) {
            const indexSize = data.sizes.findIndex(size => size === sizeProduct)
            if (indexSize !== -1) {
              this.$set(this.itemsFounded[product], sizeProduct, data.tiers[indexSize])
            } else {
              this.$set(this.itemsFounded[product], sizeProduct, [])
            }
          } else {
            for (const [index, size] of data.sizes.entries()) {
              this.$set(this.itemsFounded[product], size, data.tiers[index])
            }
          }
        }

        if (Object.keys(this.itemsFounded[product]).length === 0) {
          delete this.itemsFounded[product]
          modals.showMessage({ message: `El producto ${product} no se encuentra en inventario`, type: 'error' })
        } else {
          if (!this.images[product]) {
            const image = await this.getProductImage(product)
            if (image) this.$set(this.images, product, image)
          }
        }

        this.code = ''
      }
    },

    async getProductImage (product) {
      if (!product) return
      const query = gqlProduct.GET_BY_PRODUCT

      const response = await gql.query(query, { product }, false)

      if (!response) return
      if (!response.data || !response.data.getByProduct) return

      const productFind = response.data.getByProduct

      if (!productFind.images || !productFind.images.length) return

      return this.getImageURL(productFind)
    },

    getImageURL (product) {
      return `${this.imagePath}/${product.brand}/${product.folder}/${product.subfolder}/${product.images[0]}`
    },

    deleteData () {
      this.itemsFounded = {}
      this.images = {}
    },

    deleteRow (product, size) {
      if (this.itemsFounded[product] && this.itemsFounded[product][size]) {
        this.$delete(this.itemsFounded[product], size)
        if (Object.keys(this.itemsFounded[product]).length === 0) {
          this.$delete(this.itemsFounded, product)
          this.$delete(this.images, product)
        }
        modals.showMessage({ message: `Fila para ${product} talla ${size} eliminada`, type: 'success' })
      } else {
        modals.showMessage({ message: `No se encontró la fila para ${product} talla ${size}`, type: 'error' })
      }
    },

    deleteTier (product, size, tier) {
      const newTiers = [...this.itemsFounded[product][size]]
      const index = newTiers.indexOf(tier)
      if (index > -1) {
        newTiers.splice(index, 1)
        this.$set(this.itemsFounded[product], size, newTiers)
      }
    },

    addTier (product, size, tier) {
      const newTiers = [...this.itemsFounded[product][size]]
      newTiers.push(tier)
      this.$set(this.itemsFounded[product], size, newTiers)
    }
  }
}
</script>

<style lang="stylus" scoped>
.find-tier
  max-width 800px
  margin 0 auto
  padding 2rem

.input-container
  position relative
  margin-bottom 2rem

.input
  width 100%
  padding 1rem
  border 2px solid #ddd
  border-radius 8px
  font-size 1rem
  transition border-color 0.3s ease

  &:focus
    outline none
    border-color #007bff

.label
  position absolute
  left 1rem
  top 1rem
  color #999
  transition all 0.3s ease
  pointer-events none

  &.show
    top -0.5rem
    left 0.5rem
    font-size 0.8rem
    background white
    padding 0 0.5rem
    color #007bff

.results-container
  margin-top 2rem
  margin-bottom 2rem

.products-grid
  display flex
  flex-direction column
  gap 3rem

.product-section
  background white
  border-radius 12px
  box-shadow 0 4px 12px rgba(0, 0, 0, 0.1)
  padding 1.5rem
  overflow hidden

.product-name
  font-size 1.5rem
  font-weight 600
  color #333
  margin 0 0 1rem 0
  text-align center

.product-image
  width 100%
  max-width 20rem
  height auto
  object-fit cover
  border-radius 8px
  margin 0 auto 1.5rem auto
  display block
  box-shadow 0 2px 8px rgba(0, 0, 0, 0.1)

.table-container
  overflow hidden

.results-table
  width 100%
  border-collapse collapse

  thead
    background linear-gradient(135deg, #667eea 0%, #764ba2 100%)
    color white

    th
      padding 1rem
      text-align left
      font-weight 600
      font-size 1rem

  tbody
    tr
      border-bottom 1px solid #eee
      transition background-color 0.2s ease

      &:hover
        background-color #f8f9fa

      &:last-child
        border-bottom none

    td
      padding 1rem
      vertical-align top

.size-cell
  color #555
  min-width 80px
  text-align center

.tiers-cell
  min-width 250px

.tiers-list
  display flex
  flex-wrap wrap
  gap 1.5rem 2.5rem

.tier-badge
  background #007bff
  color white
  padding 0.3rem 0.8rem
  border-radius 15px
  font-size 0.85rem
  display inline-block

.no-tiers-text
  color #6c757d
  font-style italic
  font-size 0.9rem

.actions-cell
  min-width 100px
  text-align center

.delete-btn
  background none
  border none
  cursor pointer
  padding 0.5rem
  transition opacity 0.2s ease

  &:hover
    opacity 0.7

  img
    width 1rem
    height 1rem

@media (max-width: 768px)
  .find-tier
    padding 1rem

  .results-table
    font-size 0.9rem

    th, td
      padding 0.5rem

  .product-cell
    min-width 6rem
    font-size 0.85rem

  .size-cell
    min-width 6rem
    font-size 0.85rem

  .tiers-cell
    min-width 14rem

  .actions-cell
    min-width 6rem

  .tier-badge
    font-size 0.75rem
    padding 0.2rem 0.5rem

  .delete-btn
    padding 0.25rem

    img
      width 0.8rem
      height 0.8rem
</style>



// WEBPACK FOOTER //
// src/components/pages/product/FindTier.vue